<template>
  <v-checkbox
      dense
      v-bind="$attrs"
      outlined
      @change="$emit('input', $event !== null ? $event : false)"
      :error="error"
      :error-messages="error_message"
  >
    <template v-slot:label v-if="!!tooltip">
      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <span v-on="on">{{ label }}</span>
        </template>
        {{ tooltip }}
      </v-tooltip>
    </template>
    <template v-slot:label v-else>
      {{ label }}
    </template>
  </v-checkbox>
</template>

<script>

export default {
  name: 'BaseFieldCheck',
  inheritAttrs: false,
  props: {
    label: {default: null},
    tooltip: {default: null},
    property_state: {default: null},
    property_state_field_name: {default: null},
  },

  components: {},

  computed: {
    error() {
      return !!this.property_state && !!this.property_state_field_name && this.property_state[this.property_state_field_name].error
    },
    error_message() {
      if (!!!!this.property_state && !!this.property_state_field_name && this.property_state[this.property_state_field_name].error)
        return this.property_state[this.property_state_field_name].error_message
    else
      return null
    },
  },

  methods: {},

  async mounted() {
  },

  data() {
    return {}
  }
}
</script>

<style scoped lang="scss">

</style>
